module.exports = __webpack_public_path__ + "static/media/SpoqaHanSansNeo-Medium.9d46d938.woff2";